import React, { useEffect, useState } from 'react';
// @ts-expect-error ts-2307
import { parseCSV } from 'highed';
import MapApi from '../../../editor/core/highed.mapapi';
import InputWidget from '../../widgets/InputWidget';
import LocatorModal, { LocatorResult } from './LocatorModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadMapCSVAction, redrawProjectAction } from 'pages/ChartEditorPage/actions/chartEditor';
import Accordion from 'shared/Accordion';
import { RootState } from 'redux/store';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import IconButton from 'shared/buttons/IconButton';
import { InputChangeParams } from 'shared/types/commonPropTypes';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';

const PointMapSearch = () => {
  const dispatch = useDispatch();
  const { aggregatedOptions } = useSelector((state: RootState) => state.projectConfig);
  const [placeValue, setPlaceValue] = useState('');
  const [showLocatorModal, setShowLocatorModal] = useState(false);
  const [locatorResult, setLocatorResults] = useState<LocatorResult[]>([]);
  const mapApi = MapApi();

  useEffect(() => {
    dispatch(redrawProjectAction({ noAmination: true }));
  }, []);

  const onChange = (params: InputChangeParams) => {
    setPlaceValue(params.val as string);
  };

  const extractPoints = () => {
    if (aggregatedOptions?.data?.csv) {
      const parsedCSV = parseCSV(aggregatedOptions.data.csv, ';') as [number, number, string][];
      if (parsedCSV) {
        const c = parsedCSV.map((csvRecord) => csvRecord[2]);
        c.shift();
        return c;
      }
    }
    return [];
  };

  const searchForLocation = () => {
    if (!placeValue) return;

    mapApi.getLatLong(placeValue, (latlongResults: LocatorResult[]) => {
      if (!latlongResults) return;
      setShowLocatorModal(true);
      setLocatorResults(latlongResults);
    });
  };

  const closeLocatorModal = () => {
    setShowLocatorModal(false);
    setLocatorResults([]);
  };

  const deletePoint = (index: number) => {
    if (aggregatedOptions?.data?.csv) {
      const parsedCSV = parseCSV(aggregatedOptions.data.csv);
      if (parsedCSV) {
        parsedCSV.splice(index + 1, 1);
        dispatch(loadMapCSVAction({ options: parsedCSV, skipMapping: true }));
      }
    }
  };

  const addPoint = (location: LocatorResult) => {
    let parsedCSV = [];
    if (aggregatedOptions?.data?.csv) parsedCSV = parseCSV(aggregatedOptions.data.csv);
    else parsedCSV.push(['Latitude', 'Longitude', 'Name']);

    if (parsedCSV) {
      parsedCSV.push([parseFloat(location.lat), parseFloat(location.lon), location.value.split(',')[0]]);
      dispatch(loadMapCSVAction({ options: parsedCSV, skipMapping: true }));
    }
    setPlaceValue('');
  };

  return (
    <>
      <LocatorModal
        showLocatorModal={showLocatorModal}
        closeLocatorModal={closeLocatorModal}
        addPoint={addPoint}
        locatorResults={locatorResult}
      />
      <Accordion headerText="Add/remove data points" useInternalSelect={true} defaultSelection={true}>
        <div className="text-sm text-ev-grey-2">Address/place:</div>

        <div className="flex mb-4 w-full">
          <InputWidget
            className="rounded-r-none w-full"
            onChange={onChange}
            option={{}}
            value={placeValue}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') searchForLocation();
            }}
          />
          <PrimaryButton text="Search" className="rounded rounded-l-none" onClick={searchForLocation} />
        </div>

        {extractPoints().map((point, i) => {
          return (
            <div
              className="flex items-center justify-between bg-white mb-1 px-2 py-1 font-bold w-full rounded"
              key={`point_${i}`}
            >
              {point}
              <IconButton
                className="w-8 h-8 rounded"
                buttonColor={ButtonColor.Transparent}
                onClick={() => deletePoint(i)}
                icon="fa fa-trash"
              />
            </div>
          );
        })}
      </Accordion>
    </>
  );
};

export default PointMapSearch;
